import React, {useEffect, useState} from 'react';

import CachedEndpointsTable from 'dev/service-worker-components/CachedEndpointsTable';
import openEndpointsStore from 'dev/service-worker-components/openEndpointsStore';
import {
  dbConnect,
  dbDeleteAll,
  dbGetAll,
  openEndpointsDataStore,
} from 'dev/service-worker-interop/IndexedDBStore';
import CachedEndpoint, {CachedEndpointWithId} from 'dev/service-worker-interop/stores/CachedEndpoint';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal from 'ui-library/modals/Modal';

async function getCachedEndpoints(): Promise<Array<CachedEndpointWithId>> {
  const db = await dbConnect(window);
  const endpointsDataStore = openEndpointsDataStore(db);
  return dbGetAll<CachedEndpoint>(endpointsDataStore);
}

interface FastRefreshSettingsModalProps {
  clientId: string;
  onRequestClose: () => void;
}

export default function FastRefreshSettingsModal(props: FastRefreshSettingsModalProps): JSX.Element | null {
  const [endpoints, setEndpoints] = useState<Array<CachedEndpointWithId> | null>(null);

  useEffect(() => {
    if (!endpoints) {
      getCachedEndpoints().then((data) => {
        setEndpoints(data);
      });
    }
  }, [endpoints]);

  return (
    <Modal
      enableRedesign={true}
      title="Dev Cache Settings"
      fullWidth={true}
      large={true}
      wrapInForm={false}
      onRequestClose={() => {
        props.onRequestClose();
      }}
      closeableOnBackgroundClick={true}
      buttons={[
        {
          text: 'Clear Cache',
          onClick: async () => {
            await dbDeleteAll(await openEndpointsStore());
            setEndpoints(await getCachedEndpoints());
          },
        },
        {
          text: 'Close',
          cancel: true,
        },
      ]}
    >
      {endpoints != null ? (
        endpoints.length ? (
          <CachedEndpointsTable
            clientId={props.clientId}
            endpoints={endpoints}
            onUpdateEndpointsData={async () => {
              setEndpoints(await getCachedEndpoints());
            }}
          />
        ) : (
          <strong>Dev cache is empty.</strong>
        )
      ) : (
        <CenteredHorizontalThrobber />
      )}
    </Modal>
  );
}
